











































import { defineComponent, useContext } from '@nuxtjs/composition-api'
import { Pagination, Navigation } from 'swiper'
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
SwiperCore.use([Pagination, Navigation])

import HTMLContent from '~/components/solepro/HTMLContent.vue'
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue'

export default defineComponent({
    components: {
        Swiper,
        SwiperSlide,
        HTMLContent
    },
    mixins: [PageBuilderComponent],
    props: {
        node: {
            type: Object,/** define type */
            required: true
        }
    },
    setup(props) {
        const { node: content } = props as Readonly<{ [key: string]: any }>;
        const { app } = useContext()
        const upTitle = content.children.find(el => el.contentType == 'text')?.DOMContent.outerHTML;
        const title = content.children.find(el => el.contentType == 'heading')?.DOMContent.outerHTML;
        const slides = content.children.find(el => el.contentType == 'slider')?.children || []
        const swiperProps = {
            slidesPerView: "auto",
            spaceBetween: 12,
            modules: [Navigation, Pagination],
            slideClass: 'slide',
            pagination: {
                el: '.text-carousel .pagination',
                type: 'progressbar',
                progressbarFillClass: 'bg-black w-full block h-full'
            },
            navigation: {
                prevEl: '.text-carousel .navigation-prev',
                nextEl: '.text-carousel .navigation-next'
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20
                }
            }
        }

        return {
            pbStyle: content.pbStyle,
            cssClasses: content.cssClasses,
            swiperProps,
            upTitle,
            title,
            slides,
            IMAGE_STATIC_REPLACEMENT: app.$config.IMAGE_STATIC_REPLACEMENT,
            IMAGE_CDN_REPLACEMENT: app.$config.IMAGE_CDN_REPLACEMENT,
        }
    },
    methods: {
        getBgImage(jsonString) {
            const images = JSON.parse(jsonString.replaceAll('\\', ''));
            return images.desktop_image.replace(this.IMAGE_STATIC_REPLACEMENT, this.IMAGE_CDN_REPLACEMENT)
        },
    }
})
